<div class="sp-container">
  <div class="sp-row">
    <div class="sp-col sp-col-8">
      <h2 class="heading-2">سياراتي</h2>
    </div>
    <div class="sp-col sp-col-4">
      <sp-button routerLink="/home/my-cars/new">اضافه سيارة جديدة</sp-button>
    </div>
  </div>
  <div class="sp-row" *ngIf="!carsList">
    <h5 class="heading-5">لا يوجد لديك سيارات</h5>
  </div>
  <div class="sp-row" *ngIf="carsList && !carsList.length">
    <h5 class="heading-5">جاري جلب سياراتك ...</h5>
  </div>
  <div class="sp-row" *ngIf="carsList && carsList.length">
    <div class="sp-col sp-col-12">
      <sp-table>
        <sp-table-head>
          <sp-table-head-cell>الشركة المصنعة</sp-table-head-cell>
          <sp-table-head-cell>اسم السيارة</sp-table-head-cell>
          <sp-table-head-cell>سنة الصنع</sp-table-head-cell>
          <sp-table-head-cell width="15%"></sp-table-head-cell>
        </sp-table-head>
        <sp-table-body>
          <sp-table-body-row
            *ngFor="let car of carsList; let i = index"
            [title]="car.manufactureId.nameArabic + ' ' + car.modelId.nameArabic + ' ' + car.modelYear"
          >
            <sp-table-body-cell label="الشركة المصنعة">{{ car.manufactureId.nameArabic }}</sp-table-body-cell>
            <sp-table-body-cell label="اسم السيارة">{{ car.modelId.nameArabic }}</sp-table-body-cell>
            <sp-table-body-cell label="سنة الصنع">{{ car.modelYear }}</sp-table-body-cell>
            <sp-table-body-cell label="اجراءات">
              <div class="action-buttons">
                <sp-button [style]="'ghost'" routerLink="/home/my-cars/update/{{ car._id }}">
                  تعديل
                </sp-button>
                <sp-button [style]="'ghost'" [disabled]="deleting" (clickAction)="deleteCar(car._id)">حذف</sp-button>
              </div>
            </sp-table-body-cell>
          </sp-table-body-row>
        </sp-table-body>
      </sp-table>
    </div>
  </div>
</div>
